module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/more-topic-3.be77409f.jpg";